import DTSTAMP from './DTSTAMP'

/**
 * RDATE property.
 *
 * @see https://tools.ietf.org/html/rfc5545#section-3.8.5.2
 */
export class RDATE extends DTSTAMP {
  static propName = 'RDATE'
}



// WEBPACK FOOTER //
// ./src/properties/RDATE.js